import BaseAPI from "../base";

class SphService extends BaseAPI {
  // 获取验证码
  getPhoneCode(params) {
    return this.post({
      url: "/work/shangyaoyun/phone-code-get",
      data: params,
    });
  }

  // 提交表单
  workAdd(params) {
    return this.post({
      url: "/work/shangyaoyun/work-add",
      data: params,
    });
  }
}

export default new SphService();
